export default class ACPComment {
    selectors = {
        modal: '#submit-comment',
        disclosureCheckbox: '#comment-disclosures-checkbox',
        disclosuresWrapper: '.disclosures__wrapper',
        form: 'form',
        formSubmit: '[type=submit]',
        resetForm: '.reset-form',
        modalToggle: '.comments__info [data-toggle="modal"]',
        commentMessageToggle: 'comment-message-toggle',
        commentDescription: '.comment__description'
    };

    elements = {
        modal: null,
        disclosureCheckbox: null,
        form: null,
        formSubmit: null,
        disclosuresWrapper: null,
        resetForm: null,
        commentMessageToggle: null,
        modalToggle: null,
        commentDescription: []
    };

    inputs = {
        name: null,
        title: null,
        affiliation: null,
        comment: null,
        disclosures: null,
    };

    tinyMCE = [];
    doi: string;
    shouldAddListeners = false;

    constructor() {
        this.init();
    }

    init() {
        this.setElements();
        this.unEscapeCommentDescriptionHTML();
        this.addListeners();
    }

    private setElements() {
        this.elements.modal = document.querySelector(this.selectors.modal);
        this.elements.commentDescription = Array.from(document.querySelectorAll(this.selectors.commentDescription));
        this.shouldAddListeners = this.elements.modal != null;
        if (!this.shouldAddListeners) {
            return;
        }
        this.elements.modalToggle = document.querySelector(this.selectors.modalToggle);
        for (let key in this.elements) {
            if (!!this.elements[key]) {
                continue;
            }
            if (key === 'commentMessageToggle') {
                this.elements.commentMessageToggle = document.getElementById(this.selectors.commentMessageToggle);
                continue;
            }
            this.elements[key] = this.elements.modal.querySelector(this.selectors[key]);
        }

        this.triggerDialog();
    }

    private triggerDialog(){
        const targetNode = document.querySelector('[data-pb-dropzone="main"]');

        const config = { childList: true};

        const callback = (mutationList, observer) => {
            const dialog = document.querySelector('#comment-message');
            if(!dialog) return;
            this.elements.commentMessageToggle?.click();
            observer.disconnect();
            };

        const observer = new MutationObserver(callback);
        targetNode && observer.observe(targetNode, config); 
    }

    /**
     * since the comment body is escaped on back-end side, and it's not safe to unescape it from their end,
     * there might CSRF attacks in the content and we need to prevent that.
     * since it's already escaped from their end, just to make the comment visualized we unescape it from our end
     *
     * @private
     */
    private unEscapeCommentDescriptionHTML() {
        const txt = document.createElement("textarea");
        this.elements.commentDescription.forEach(comment => {
            txt.innerHTML = comment.innerHTML;
            comment.innerHTML = txt.value;
        });
    }

    private addListeners() {
        if (!this.shouldAddListeners) {
            return;
        }
        this.elements.disclosureCheckbox?.addEventListener('click', this.toggleDisclosure.bind(this));
        this.elements.resetForm?.addEventListener('click', this.resetForm.bind(this));
        this.elements.modalToggle?.addEventListener('click', this.initTinyMCE.bind(this, '#comment-body'));
    }

    private async toggleDisclosure(e) {
        const wrapper: HTMLElement = this.elements.disclosuresWrapper;
        wrapper?.classList.toggle('active');
        await this.initTinyMCE('#comment-disclosures');
        wrapper?.setAttribute('aria-hidden', (!wrapper.classList?.contains('active')).toString());
    }

    private resetForm() {
        this.elements.modal.querySelector('.modal__form')?.classList.remove('hidden');
        this.elements.modal.querySelector('.modal__message')?.classList.add('hidden');
        for (let key in this.inputs) {
            this.inputs[key].element.value = null;
        }
        this.tinyMCE.forEach(mce => mce.editors[0].setContent(''))
    }

    private async initTinyMCE(selector) {
        if (this.tinyMCE.length > 1) {
            return;
        }
        try {
            await this.tinyMCEScript();
            const settings = {
                plugins: 'lists paste',
                height: 200,
                toolbar: [
                    'bold italic | alignleft aligncenter alignright | bullist numlist outdent indent',
                ],
                setup: function (editor) {
                    editor.on('change', function () {
                        editor.save();
                    });
                }
            };
            // @ts-ignore
            this.tinyMCE.push(window.tinymce.init({
                selector,
                ...settings
            }));

        } catch (e) {
        }
    }

    private async tinyMCEScript() {
        return new Promise<void>((resolve, reject) => {
            // @ts-ignore
            if (window.tinymce) {
                resolve();
            } else {
                let htmlTag = document.createElement('script');
                htmlTag.type = 'text/javascript';
                htmlTag.src = '/resources/page-builder/js/lib/tinymce-5.0.13/tinymce.min.js';
                htmlTag.addEventListener('load', () => resolve(), false);
                htmlTag.addEventListener('error', () => {
                    htmlTag.remove();
                    reject();
                }, false);
                document.body.appendChild(htmlTag);
            }

        });
    };
}
